import { fromJS } from 'immutable';
import { actions } from 'react/api/actions/photoAlbum';

const initialState = fromJS({
  selectedAlbums: {},
  isLoading: false
});

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.addAllPhotosToAlbum: {
      const {
        payload: { albumId, photos }
      } = action;
      return state.setIn(['selectedAlbums', String(albumId)], fromJS(photos));
    }

    case actions.addAllPhotosAlbums: {
      const { payload } = action;

      const transformedPayload = payload.reduce((acc, album) => {
        const [albumId, photos] = Object.entries(album)[0];
        acc[albumId] = fromJS(photos);
        return acc;
      }, {});

      return state.mergeIn(['selectedAlbums'], fromJS(transformedPayload));
    }

    case actions.deselectAlbum: {
      return state.removeIn(['selectedAlbums', String(action.payload.albumId)]);
    }

    case actions.deselectAlbums: {
      const actualState = state.get('selectedAlbums').toJS();

      const updatedSelectedAlbums = Object.keys(actualState).reduce((acc, albumId) => {
        if (!action.payload.albumIds.includes(Number(albumId))) {
          acc[albumId] = actualState[albumId];
        }
        return acc;
      }, {});

      return state.set('selectedAlbums', fromJS(updatedSelectedAlbums));
    }

    case actions.selectPhoto:
      return state.updateIn(
        ['selectedAlbums', String(action.payload.albumId)],
        (photos = fromJS([])) => photos.push(action.payload.photo)
      );

    case actions.deselectPhoto: {
      const { albumId, photoId } = action.payload;

      return state.updateIn(
        ['selectedAlbums', String(albumId)],
        (photos = fromJS([])) => {
          const updatedPhotos = photos.filter((photo) => fromJS(photo).get('id') !== photoId);
          return updatedPhotos.size === 0 ? undefined : updatedPhotos;
        }
      );
    }

    case actions.setLoading: {
      return state.set(['isLoading'], action.payload.isLoading);
    }

    case actions.clear:
      return initialState;

    default:
      return state;
  }
};
